export default __webpack_public_path__ + "static/media/DataDashboardSmoke_001.3461cbba.png";